import { actionBound, makeObservable, observable } from "mobx";
import {
    closeInstantShipTask,
    getCurrentInstantShipTask,
    InstantShipTask,
    openInstantShipTask,
    OpenInstantShipTaskParams,
} from "@/services/api/instantShip";

export default class InstantShipStore {
    constructor() {
        makeObservable(this, {
            currentTask: observable,
            loadingCurrentTask: observable,
            loadCurrentTask: actionBound,
            openTask: actionBound,
            closeTask: actionBound,
            reset: actionBound,
        });
    }

    currentTask?: InstantShipTask;

    loadingCurrentTask = false;

    private currentRequestId = 0;

    async loadCurrentTask(shopId: number, hideModal = true) {
        const requestId = ++this.currentRequestId;
        this.loadingCurrentTask = true;

        try {
            const result = await getCurrentInstantShipTask(shopId, { hideModal });

            if (requestId !== this.currentRequestId) return;

            this.currentTask = result || undefined;
            return this.currentTask;
        } catch (error) {
            if (!hideModal) {
                if (requestId === this.currentRequestId) {
                    this.currentTask = undefined;
                }

                throw error;
            }

            return this.currentTask;
        } finally {
            if (requestId === this.currentRequestId) {
                this.loadingCurrentTask = false;
            }
        }
    }

    async openTask(params: OpenInstantShipTaskParams) {
        this.currentRequestId += 1;
        const result = await openInstantShipTask(params);

        this.currentTask = result;
        return result;
    }

    async closeTask(shopId: number) {
        this.currentRequestId += 1;
        const result = await closeInstantShipTask(shopId);
        this.currentTask = undefined;
        return result;
    }

    reset() {
        this.currentRequestId += 1;
        this.currentTask = undefined;
        this.loadingCurrentTask = false;
    }
}
